import { Controller } from '@hotwired/stimulus';
import { createConsumer } from '@rails/actioncable';

export default class extends Controller {
  static values = { uuid: String, url: String }

  connect() {
    if (this.hasUuidValue) {
      this.initSubscription();
    }
  }

  load() {
    fetch(this.urlValue)
      .then((response) => response.text())
      .then((html) => this.element.innerHTML = html);
  }

  initSubscription() {
    this.channel = createConsumer().subscriptions.create(
      {
        channel: 'RPAScripts::ExecutionChannel',
        uuid: this.uuidValue
      },
      {
        received: this.load.bind(this)
      }
    );
  }
}
